import { Component } from '@angular/core';
import { cdnUrl } from 'apps/ihowebsite/src/app/app.module';;

@Component({
  selector: 'iho-iranhotel-info',
  templateUrl: './iranhotel-info.component.html',
  styleUrls: ['./iranhotel-info.component.scss'],
})
export class IranhotelInfoComponent {
  showCollapseInfo = false;
  cdnUrl = cdnUrl
}
